import { firebase, firestore } from '@/components/utils/firebase'
import { initializeDatabase } from '@shared/database'
import Vue from 'vue'
import Router from 'vue-router'
import App from './App.vue'
import './plugins/vuetify'
import router from './router'
import store from './store'
import VueMask from 'v-mask'

initializeDatabase(firestore, {
  FieldValue: firebase.firestore.FieldValue
})

Vue.use(VueMask)

Vue.config.productionTip = false
const routerPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(error => error)
}

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
